module.exports = __webpack_public_path__ + "media/images/a_estrategico-19d77919.png";